import angular from 'angular';

import SignInModule from './sign-in';
import SignUpModule from './sign-up';
import ForgotPasswordModule from './forgot-password';
import EmailVerificationModule from './email-verification';
import ChangeEmailModule from './change-email';

export default angular
    .module('application.scene.identity.scene', [
        SignInModule.name,
        SignUpModule.name,
        ForgotPasswordModule.name,
        EmailVerificationModule.name,
        ChangeEmailModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/index.js